import { FC } from 'react';

export const Stop: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 4C7.58172 4 4 7.58172 4 12C4 13.8487 4.62708 15.551 5.68014 16.9056L16.9056 5.68014C15.551 4.62708 13.8487 4 12 4ZM18.3199 7.09436L7.09436 18.3199C8.44904 19.3729 10.1513 20 12 20C16.4183 20 20 16.4183 20 12C20 10.1513 19.3729 8.44904 18.3199 7.09436ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
			fill="currentColor"
		/>
	</svg>
);
